





























import { defineComponent, inject, computed, ref } from '@vue/composition-api'

// Store
import { StoreKey } from '@/store/Input'
import { StoreKey as ErrorStoreKey } from '@/store/Error'

// Util
import { useValidate } from '@/ts/util/validate'

export default defineComponent({
    setup() {
        const store = inject(StoreKey)
        if (!store) {
            throw new Error(`${StoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }

        const isInputted = ref(false)

        const validateHandler = useValidate({}, (result, flag, inputted) => {
            isInputted.value = inputted as boolean
        })

        const inputFieldClass = computed(() => {
            return {
                'm-invalid': errorStore.construction.value !== null,
                'm-verify': isInputted.value,
            }
        })

        return {
            store,
            errorStore,
            inputFieldClass,
            validateHandler,
        }
    },
})
